import { useField } from "formik";

export const useIsEmail = () => {
  const [{ value }] = useField("is_email");

  return Boolean(value);
};
